"use client";

import { AdvertiserCarousel } from "@/app/[lng]/_components/advertiser-carousel";
import { AdvertiserCarouselSkeleton } from "@/app/[lng]/_components/advertiser-carousel-skeleton";
import { useHomeContext } from "@/components/Home/home-context";
import { Suspense } from "react";

export function HomeAdvertiserCarousel() {
  const { startLocation, endLocation } = useHomeContext();
  return (
    <Suspense fallback={<AdvertiserCarouselSkeleton />}>
      <AdvertiserCarousel
        startLocation={startLocation}
        endLocation={endLocation}
      />
    </Suspense>
  );
}
